/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OdometerState
 */
export interface OdometerState {
    /**
     * 
     * @type {number}
     * @memberof OdometerState
     */
    meters: number;
    /**
     * 
     * @type {Date}
     * @memberof OdometerState
     */
    time: Date;
}

export function OdometerStateFromJSON(json: any): OdometerState {
    return OdometerStateFromJSONTyped(json, false);
}

export function OdometerStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OdometerState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meters': json['meters'],
        'time': (new Date(json['time'])),
    };
}

export function OdometerStateToJSON(value?: OdometerState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meters': value.meters,
        'time': (value.time.toISOString()),
    };
}


